import { Actions } from '../constants/products/actions';
import Dispatcher from '../dispatcher';

export function setAction(products) {
    Dispatcher.handleProductsAction({
        type: Actions.SET_PRODUCT,
        payload: products,
    });
}

export function addAction(product) {
    Dispatcher.handleProductsAction({
        type: Actions.ADD_PRODUCT,
        payload: product,
    });
}

export function removeAction(productId) {
    Dispatcher.handleProductsAction({
        type: Actions.REMOVE_PRODUCT,
        payload: productId,
    });
}

export function updateAction(product) {
    Dispatcher.handleProductsAction({
        type: Actions.UPDATE_PRODUCT,
        payload: product,
    });
}
